module.exports = __webpack_public_path__ + "img/bg3.4f098233.png";